import React from 'react';
import PropTypes from 'prop-types';
import {Bar} from "react-chartjs-2";
import {useIntl} from "react-intl";
import moment from "moment";
import {blueColor, green600, greyishBlue100, greyishBlue500, orange600} from "assets/jss/main";
import {WmsStatsPeriod} from "api/wms/stats/stats";

export const FLOW_SERIES = [
    {key: 'picked', color: blueColor, labelId: 'wms.admin_wms_stats.flow.picked'},
    {key: 'sorted', color: green600, labelId: 'wms.admin_wms_stats.flow.sorted'},
    {key: 'packed', color: orange600, labelId: 'wms.admin_wms_stats.flow.packed'},
]

export function formatBucketLabel(row, period) {
    if (period === WmsStatsPeriod.TODAY) {
        return `${row.hour}h`
    }

    return moment(row.day).format('ddd D/MM')
}

FlowChart.propTypes = {
    rows: PropTypes.array.isRequired,
    period: PropTypes.oneOf(Object.values(WmsStatsPeriod)).isRequired
};

function FlowChart({rows, period}) {
    const intl = useIntl()

    const data = {
        labels: rows.map(row => formatBucketLabel(row, period)),
        datasets: FLOW_SERIES.map(series => ({
            label: intl.formatMessage({id: series.labelId}),
            data: rows.map(row => row[series.key]),
            backgroundColor: series.color,
            borderWidth: 0,
            barPercentage: 0.8,
            categoryPercentage: 0.6
        }))
    }

    const options = {
        maintainAspectRatio: false,
        legend: {
            display: true,
            position: 'bottom',
            labels: {boxWidth: 12, fontColor: greyishBlue500}
        },
        tooltips: {mode: 'index', intersect: false},
        scales: {
            xAxes: [{
                gridLines: {display: false},
                ticks: {fontColor: greyishBlue500, autoSkip: true, maxRotation: 0}
            }],
            yAxes: [{
                ticks: {beginAtZero: true, precision: 0, fontColor: greyishBlue500},
                gridLines: {color: greyishBlue100, drawBorder: false}
            }]
        }
    }

    return (
        <div style={{height: "260px"}}>
            <Bar data={data} options={options}/>
        </div>
    );
}

export default FlowChart;
